<script setup lang="ts">
defineProps<{ content: CTAContent[] }>()

const currentArticle = inject(keys.currentArticle)

interface ThemeAssociation {
  themes: string[]
  backgroundClass: string
  images: string[]
}

const themeBackgroundAssociation: Array<ThemeAssociation> = [
  {
    themes: ['dark-green-pink', 'dark-red-pink', 'blue-pink'],
    backgroundClass: 'bg-coral-legacy-10',
    images: ['rosa_ill1.svg', 'rosa_ill2.svg'],
  },
  {
    themes: ['green-seagreen', 'seagreen-light-blue'],
    backgroundClass: 'bg-green-5',
    images: ['gronn_ill1.svg', 'gronn_ill2.svg'],
  },
  {
    themes: ['green-yellow-light', 'gray-yellow'],
    backgroundClass: 'bg-yellow-legacy-20',
    images: ['gul_ill1.svg', 'gul_ill2.svg'],
  },
]

const bg = computed(() => {
  const theme = currentArticle?.colorTheme
  if (theme) {
    const association = themeBackgroundAssociation.find((a) =>
      a.themes.includes(theme),
    )
    if (association) {
      return {
        backgroundClass: association.backgroundClass,
        images: association.images,
      }
    }
  }
  return {
    backgroundClass: 'bg-coral-legacy-10',
    images: ['rosa_ill1.svg', 'rosa_ill2.svg'],
  }
})

const linkConfig = useCtaLinks()
</script>

<template>
  <div
    v-for="(ctaContent, index) in content"
    :key="index"
    class="relative flex h-auto w-120 max-w-[90dvw] flex-col items-center gap-4 rounded-xl border border-white p-8 pb-16 text-center text-green-50"
    :class="bg.backgroundClass"
  >
    <StaticAsset
      v-if="bg.images[index]"
      folder="graphics"
      :file="bg.images[index]"
      aria-hidden="true"
      class="m-0"
    />
    <h3 class="text-xl font-semibold" v-text="ctaContent.title" />
    <div class="pb-5 text-lg font-normal" v-html="ctaContent.content" />
    <UButton
      v-if="ctaContent.link"
      class="h-fit rounded-full bg-yellow-legacy-30 px-legacy-m py-legacy-s text-lg text-wrap text-[--ui-text] no-underline hover:bg-yellow-legacy-40"
      :to="ctaContent.link"
    >
      {{ ctaContent.label }}
    </UButton>
    <p v-if="ctaContent.links.length > 0" class="pt-5 text-lg font-normal">
      Har du ikke tilgang?
    </p>
    <NuxtLink
      v-for="link in ctaContent.links"
      :key="link"
      :to="linkConfig[link].to"
      class="font-semibold !whitespace-break-spaces"
    >
      {{ linkConfig[link].label }}
    </NuxtLink>
  </div>
</template>
